import { Button, Fab, Zoom } from "@material-ui/core"
import { Save } from "@material-ui/icons"

type Props = {
    save: () => void
    hasChanges: boolean
    isValid: boolean
}

export function ProfileSaveButton({
    save,
    hasChanges,
    isValid,
}: Props) {
    return (
        <>
            <Zoom in={hasChanges}>
                <Button
                    startIcon={<Save />}
                    disabled={!isValid}
                    aria-label="save"
                    style={{ marginBottom: -20 }}
                    variant="contained"
                    color="primary"
                    onClick={save}
                >Lagre Endringer</Button>
            </Zoom>
            <Zoom in={hasChanges}>
                <Fab
                    onClick={save}
                    disabled={!isValid}
                    style={{
                        position: 'fixed',
                        bottom: 20,
                        right: 20,
                        zIndex: 1050,
                    }}
                    color="primary"
                    aria-label="save"
                >
                    <Save />
                </Fab>
            </Zoom>
        </>
    )
}